import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HeadwordSearchService } from '../services/headword-search.service';
import { FavoriteSearchService } from '../services/favorite-search.service';
import { HistorySearchService } from '../services/history-search.service';
import { ISearchService } from '../services/ISearchService';
import { NavigationService } from '../services/navigation.service';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit, OnDestroy {

  // define whether component is for search, history or favorites
  type = 'search';
  query = '';
  word = '';
  morph = false;
  selectedSearchService: ISearchService;
  routeSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private headwordSearchService: HeadwordSearchService,
    private favoriteSearchService: FavoriteSearchService,
    private historySearchService: HistorySearchService,
  ) { }

  ngOnInit() {
    this.initializeSearch();
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.initializeSearch();
      }
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  initializeSearch() {
    this.route.data.subscribe(data => {
      this.type = data.type;
      switch (this.type) {
        case 'search':
          this.selectedSearchService = this.headwordSearchService;
          break;
        case 'favourite':
          this.selectedSearchService = this.favoriteSearchService;
          break;
        case 'history':
          this.selectedSearchService = this.historySearchService;
          break;
      }
    });

    this.route.queryParams.subscribe(params => {
      this.query = params.query ?? '';
      let word = params.word ?? '';
      this.morph = (this.query !== '' && word === '');

      if (this.morph) {
        word = this.query;
      }

      if (word !== '') {
        this.selectWord(word);
      }
    });
  }

  selectWord(word: string) {
    this.word = word;
  }

  search(query: string, word: string) {
    this.router.navigate([`/${ this.type }`], { queryParams: { query, word } });
  }

}
